// middleware/completed-account.ts
export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuthStore()

  // if we have a token but no full user yet, pull it down
  if (auth.logged && !auth.user.name) {
    await auth.fetchUser()
  }

  const locale   = auth.user.preferred_language || 'en'
  const basePath = (auth.user.profile.onboarding_complete || auth.user.profile.onboarding_skip)
    ? '/account/profile'
    : '/onboarding'

  const target = locale === 'en'
    ? basePath
    : `/${locale}${basePath}`

  if (
    auth.logged &&
    auth.user.account_status === 'complete' &&
    to.path !== target
  ) {
    return navigateTo(target)
  }
})
